import Vue from 'vue'
import App from './App.vue'
// import router from '../router'
import router from '../router/main'
import store from '../store'
// import VueGtag from 'vue-gtag'
import '../i18n/index'

// vuetify (l'ordine è fondamentale, da lasciare qui)
import vuetify from '@/plugins/vuetify/vuetify' // path to vuetify export

// owl-carousel per vue
import carousel from 'vue-owl-carousel'
import {
  BootstrapVue
} from 'bootstrap-vue'
// Import Bootstrap an BootstrapVue CSS files (order is important)
//  import 'bootstrap/dist/css/bootstrap.css'
// https://italia.github.io/bootstrap-italia
import 'bootstrap-italia/dist/css/bootstrap-italia.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// fontawasome
import '@fortawesome/fontawesome-free/css/all.min.css'

// css custom per il progetto
import '@/static/css/common.css'

Vue.config.productionTip = false

Vue.use(carousel)
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)
/*
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID
  }
})
*/

/*
router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})
*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  store,
  render: h => h(App)
})
